import { render, staticRenderFns } from "./Nutanix.vue?vue&type=template&id=4c778cb6&"
import script from "./Nutanix.vue?vue&type=script&lang=js&"
export * from "./Nutanix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports